{
  "stench": {
    "name": "Stench",
    "num": 1,
    "desc": "By releasing stench when attacking, this Pokemon\nmay cause the target to flinch.",
    "shortDesc": "By releasing stench when attacking, this Pokemon\nmay cause the target to flinch."
  },
  "drizzle": {
    "name": "Drizzle",
    "num": 2,
    "desc": "The Pokemon makes it rain when it enters a battle.",
    "shortDesc": "The Pokemon makes it rain when it enters a battle."
  },
  "speedboost": {
    "name": "Speed Boost",
    "num": 3,
    "desc": "Its Speed stat is boosted every turn.",
    "shortDesc": "Its Speed stat is boosted every turn."
  },
  "battlearmor": {
    "name": "Battle Armor",
    "num": 4,
    "desc": "Hard armor protects the Pokemon from critical hits.",
    "shortDesc": "Hard armor protects the Pokemon from critical hits."
  },
  "sturdy": {
    "name": "Sturdy",
    "num": 5,
    "desc": "It cannot be knocked out with one hit. One-hit KO\nmoves cannot knock it out, either.",
    "shortDesc": "It cannot be knocked out with one hit. One-hit KO\nmoves cannot knock it out, either."
  },
  "damp": {
    "name": "Damp",
    "num": 6,
    "desc": "Prevents the use of explosive moves such as\nSelf-Destruct by dampening its surroundings.",
    "shortDesc": "Prevents the use of explosive moves such as\nSelf-Destruct by dampening its surroundings."
  },
  "limber": {
    "name": "Limber",
    "num": 7,
    "desc": "Its limber body protects the Pokemon from paralysis.",
    "shortDesc": "Its limber body protects the Pokemon from paralysis."
  },
  "sandveil": {
    "name": "Sand Veil",
    "num": 8,
    "desc": "Boosts the Pokemon’s evasion in a sandstorm.",
    "shortDesc": "Boosts the Pokemon’s evasion in a sandstorm."
  },
  "static": {
    "name": "Static",
    "num": 9,
    "desc": "The Pokemon is charged with static electricity, so\ncontact with it may cause paralysis.",
    "shortDesc": "The Pokemon is charged with static electricity, so\ncontact with it may cause paralysis."
  },
  "voltabsorb": {
    "name": "Volt Absorb",
    "num": 10,
    "desc": "Restores HP if hit by an Electric-type move, instead\nof taking damage.",
    "shortDesc": "Restores HP if hit by an Electric-type move, instead\nof taking damage."
  },
  "waterabsorb": {
    "name": "Water Absorb",
    "num": 11,
    "desc": "Restores HP if hit by a Water-type move, instead of\ntaking damage.",
    "shortDesc": "Restores HP if hit by a Water-type move, instead of\ntaking damage."
  },
  "oblivious": {
    "name": "Oblivious",
    "num": 12,
    "desc": "The Pokemon is oblivious, and that keeps it from\nbeing infatuated or falling for taunts.",
    "shortDesc": "The Pokemon is oblivious, and that keeps it from\nbeing infatuated or falling for taunts."
  },
  "cloudnine": {
    "name": "Cloud Nine",
    "num": 13,
    "desc": "Eliminates the effects of weather.",
    "shortDesc": "Eliminates the effects of weather."
  },
  "sixthsense": {
    "name": "Sixth Sense",
    "num": 14,
    "desc": "This Pokemon’s accuracy is boosted by 30%.",
    "shortDesc": "This Pokemon’s accuracy is boosted by 30%."
  },
  "insomnia": {
    "name": "Insomnia",
    "num": 15,
    "desc": "The Pokemon is suffering from insomnia and cannot\nfall asleep.",
    "shortDesc": "The Pokemon is suffering from insomnia and cannot\nfall asleep."
  },
  "colorchange": {
    "name": "Color Change",
    "num": 16,
    "desc": "The Pokemon’s type becomes the type of the move\nused on it.",
    "shortDesc": "The Pokemon’s type becomes the type of the move\nused on it."
  },
  "immunity": {
    "name": "Immunity",
    "num": 17,
    "desc": "The immune system of the Pokemon prevents it from\ngetting poisoned.",
    "shortDesc": "The immune system of the Pokemon prevents it from\ngetting poisoned."
  },
  "flashfire": {
    "name": "Flash Fire",
    "num": 18,
    "desc": "Powers up the Pokemon’s Fire-type moves if it’s hit\nby one.",
    "shortDesc": "Powers up the Pokemon’s Fire-type moves if it’s hit\nby one."
  },
  "shielddust": {
    "name": "Shield Dust",
    "num": 19,
    "desc": "This Pokemon’s dust blocks the additional effects of\nattacks taken.",
    "shortDesc": "This Pokemon’s dust blocks the additional effects of\nattacks taken."
  },
  "owntempo": {
    "name": "Own Tempo",
    "num": 20,
    "desc": "This Pokemon has its own tempo, and that prevents\nit from becoming confused.",
    "shortDesc": "This Pokemon has its own tempo, and that prevents\nit from becoming confused."
  },
  "suctioncups": {
    "name": "Suction Cups",
    "num": 21,
    "desc": "This Pokemon uses suction cups to stay in one spot\nto negate all moves and items that force\nswitching out.",
    "shortDesc": "This Pokemon uses suction cups to stay in one spot\nto negate all moves and items that force\nswitching out."
  },
  "intimidate": {
    "name": "Intimidate",
    "num": 22,
    "desc": "The Pokemon intimidates opposing Pokemon upon\nentering battle, lowering their Attack stat.",
    "shortDesc": "The Pokemon intimidates opposing Pokemon upon\nentering battle, lowering their Attack stat."
  },
  "shadowtag": {
    "name": "Shadow Tag",
    "num": 23,
    "desc": "This Pokemon steps on the opposing Pokemon’s\nshadow to prevent it from escaping.",
    "shortDesc": "This Pokemon steps on the opposing Pokemon’s\nshadow to prevent it from escaping."
  },
  "roughskin": {
    "name": "Rough Skin",
    "num": 24,
    "desc": "This Pokemon inflicts damage with its rough skin\nto the attacker on contact.",
    "shortDesc": "This Pokemon inflicts damage with its rough skin\nto the attacker on contact."
  },
  "wonderguard": {
    "name": "Wonder Guard",
    "num": 25,
    "desc": "Its mysterious power only lets supereffective moves\nhit the Pokemon.",
    "shortDesc": "Its mysterious power only lets supereffective moves\nhit the Pokemon."
  },
  "levitate": {
    "name": "Levitate",
    "num": 26,
    "desc": "By floating in the air, the Pokemon receives full\nimmunity to all Ground-type moves.",
    "shortDesc": "By floating in the air, the Pokemon receives full\nimmunity to all Ground-type moves."
  },
  "effectspore": {
    "name": "Effect Spore",
    "num": 27,
    "desc": "Contact with the Pokemon may inflict poison, sleep,\nor paralysis on its attacker.",
    "shortDesc": "Contact with the Pokemon may inflict poison, sleep,\nor paralysis on its attacker."
  },
  "synchronize": {
    "name": "Synchronize",
    "num": 28,
    "desc": "The attacker will receive the same status condition if\nit inflicts a burn, poison, or paralysis to the Pokemon.",
    "shortDesc": "The attacker will receive the same status condition if\nit inflicts a burn, poison, or paralysis to the Pokemon."
  },
  "clearbody": {
    "name": "Clear Body",
    "num": 29,
    "desc": "Prevents other Pokemon’s moves or Abilities from\nlowering the Pokemon’s stats.",
    "shortDesc": "Prevents other Pokemon’s moves or Abilities from\nlowering the Pokemon’s stats."
  },
  "naturalcure": {
    "name": "Natural Cure",
    "num": 30,
    "desc": "All status conditions heal when the Pokemon\nswitches out.",
    "shortDesc": "All status conditions heal when the Pokemon\nswitches out."
  },
  "lightningrod": {
    "name": "Lightning Rod",
    "num": 31,
    "desc": "The Pokemon draws in all Electric-type moves. \nInstead of being hit by Electric-type moves, \nit boosts its Sp. Atk.",
    "shortDesc": "The Pokemon draws in all Electric-type moves. \nInstead of being hit by Electric-type moves, \nit boosts its Sp. Atk."
  },
  "serenegrace": {
    "name": "Serene Grace",
    "num": 32,
    "desc": "Doubles the likelihood of additional effects occurring \nwhen attacking.",
    "shortDesc": "Doubles the likelihood of additional effects occurring \nwhen attacking."
  },
  "swiftswim": {
    "name": "Swift Swim",
    "num": 33,
    "desc": "Doubles the Pokemon’s Speed stat in rain.",
    "shortDesc": "Doubles the Pokemon’s Speed stat in rain."
  },
  "solarrush": {
    "name": "Solar Rush",
    "num": 34,
    "desc": "Doubles the Pokemon’s Speed stat in harsh sunlight.",
    "shortDesc": "Doubles the Pokemon’s Speed stat in harsh sunlight."
  },
  "illuminate": {
    "name": "Illuminate",
    "num": 35,
    "desc": "Raises the likelihood of meeting wild Pokemon by\nilluminating the surroundings.",
    "shortDesc": "Raises the likelihood of meeting wild Pokemon by\nilluminating the surroundings."
  },
  "trace": {
    "name": "Trace",
    "num": 36,
    "desc": "When it enters a battle, the Pokemon copies an\nopposing Pokemon’s Ability.",
    "shortDesc": "When it enters a battle, the Pokemon copies an\nopposing Pokemon’s Ability."
  },
  "hugepower": {
    "name": "Huge Power",
    "num": 37,
    "desc": "Doubles the Pokemon’s Attack stat.",
    "shortDesc": "Doubles the Pokemon’s Attack stat."
  },
  "poisonpoint": {
    "name": "Poison Point",
    "num": 38,
    "desc": "Contact with the Pokemon may poison the attacker.",
    "shortDesc": "Contact with the Pokemon may poison the attacker."
  },
  "innerfocus": {
    "name": "Inner Focus",
    "num": 39,
    "desc": "The Pokemon’s intensely focused, and that protects\nthe Pokemon from flinching.",
    "shortDesc": "The Pokemon’s intensely focused, and that protects\nthe Pokemon from flinching."
  },
  "magmaarmor": {
    "name": "Magma Armor",
    "num": 40,
    "desc": "The Pokemon is covered with hot magma, which\nprevents the Pokemon from becoming frozen.",
    "shortDesc": "The Pokemon is covered with hot magma, which\nprevents the Pokemon from becoming frozen."
  },
  "waterveil": {
    "name": "Water Veil",
    "num": 41,
    "desc": "The Pokemon is covered with a water veil, which\nprevents the Pokemon from getting a burn.",
    "shortDesc": "The Pokemon is covered with a water veil, which\nprevents the Pokemon from getting a burn."
  },
  "magnetpull": {
    "name": "Magnet Pull",
    "num": 42,
    "desc": "Prevents Steel-type Pokemon from escaping using\nits magnetic force.",
    "shortDesc": "Prevents Steel-type Pokemon from escaping using\nits magnetic force."
  },
  "sinister": {
    "name": "Sinister",
    "num": 43,
    "desc": "This Pokemon is immune to Fairy-type moves.\nThis does not protect against Pixilate.",
    "shortDesc": "This Pokemon is immune to Fairy-type moves.\nThis does not protect against Pixilate."
  },
  "raindish": {
    "name": "Rain Dish",
    "num": 44,
    "desc": "The Pokemon gradually regains HP in rain.",
    "shortDesc": "The Pokemon gradually regains HP in rain."
  },
  "sandstream": {
    "name": "Sand Stream",
    "num": 45,
    "desc": "The Pokemon summons a sandstorm when it enters\na battle.",
    "shortDesc": "The Pokemon summons a sandstorm when it enters\na battle."
  },
  "pressure": {
    "name": "Pressure",
    "num": 46,
    "desc": "By putting pressure on the opposing Pokemon, it\nraises their PP usage.",
    "shortDesc": "By putting pressure on the opposing Pokemon, it\nraises their PP usage."
  },
  "thickfat": {
    "name": "Thick Fat",
    "num": 47,
    "desc": "The Pokemon is protected by a layer of thick fat,\nwhich halves the damage taken from Fire- and\nIce-type moves.",
    "shortDesc": "The Pokemon is protected by a layer of thick fat,\nwhich halves the damage taken from Fire- and\nIce-type moves."
  },
  "earlybird": {
    "name": "Early Bird",
    "num": 48,
    "desc": "The Pokemon awakens twice as fast as other\nPokemon from sleep.",
    "shortDesc": "The Pokemon awakens twice as fast as other\nPokemon from sleep."
  },
  "flamebody": {
    "name": "Flame Body",
    "num": 49,
    "desc": "Contact with the Pokemon may burn the attacker.",
    "shortDesc": "Contact with the Pokemon may burn the attacker."
  },
  "runaway": {
    "name": "Run Away",
    "num": 50,
    "desc": "Enables a sure getaway from wild Pokemon.",
    "shortDesc": "Enables a sure getaway from wild Pokemon."
  },
  "keeneye": {
    "name": "Keen Eye",
    "num": 51,
    "desc": "Keen eyes prevent other Pokemon from lowering this\nPokemon’s accuracy.",
    "shortDesc": "Keen eyes prevent other Pokemon from lowering this\nPokemon’s accuracy."
  },
  "hypercutter": {
    "name": "Hyper Cutter",
    "num": 52,
    "desc": "The Pokemon’s proud of its powerful pincers. They\nprevent other Pokemon from lowering its Attack stat.",
    "shortDesc": "The Pokemon’s proud of its powerful pincers. They\nprevent other Pokemon from lowering its Attack stat."
  },
  "database": {
    "name": "Database",
    "num": 53,
    "desc": "Picks up important items to evolve itself, as well as\nMemories and Drives. Go to the Google Sheets for\nexact percentages and items, and more.",
    "shortDesc": "Picks up important items to evolve itself, as well as\nMemories and Drives. Go to the Google Sheets for\nexact percentages and items, and more."
  },
  "truant": {
    "name": "Truant",
    "num": 54,
    "desc": "The Pokemon can’t use a move the following turn if it\nuses one.",
    "shortDesc": "The Pokemon can’t use a move the following turn if it\nuses one."
  },
  "hustle": {
    "name": "Hustle",
    "num": 55,
    "desc": "Greatly boosts the Attack stat by 50% for a 20%\naccuracy drop on most Physical moves.",
    "shortDesc": "Greatly boosts the Attack stat by 50% for a 20%\naccuracy drop on most Physical moves."
  },
  "cutecharm": {
    "name": "Cute Charm",
    "num": 56,
    "desc": "Contact with the Pokemon may cause infatuation.",
    "shortDesc": "Contact with the Pokemon may cause infatuation."
  },
  "interstellar": {
    "name": "Interstellar",
    "num": 57,
    "desc": "Boosts the Sp. Atk stat of the Pokemon if an ally\nwith the same ability is also in battle.",
    "shortDesc": "Boosts the Sp. Atk stat of the Pokemon if an ally\nwith the same ability is also in battle."
  },
  "evoboost": {
    "name": "Evoboost",
    "num": 58,
    "desc": "Boosts the Sp. Atk stat of the Pokemon if an ally\nwith the same ability is also in battle.",
    "shortDesc": "Boosts the Sp. Atk stat of the Pokemon if an ally\nwith the same ability is also in battle."
  },
  "forecast": {
    "name": "Forecast",
    "num": 59,
    "desc": "The Pokemon transforms with the weather to change\nits type to Water, Fire, or Ice.",
    "shortDesc": "The Pokemon transforms with the weather to change\nits type to Water, Fire, or Ice."
  },
  "stickyhold": {
    "name": "Sticky Hold",
    "num": 60,
    "desc": "Items held by the Pokemon are stuck fast and\ncannot be removed by other Pokemon.",
    "shortDesc": "Items held by the Pokemon are stuck fast and\ncannot be removed by other Pokemon."
  },
  "shedskin": {
    "name": "Shed Skin",
    "num": 61,
    "desc": "The Pokemon may heal its own status conditions\nby shedding its skin.",
    "shortDesc": "The Pokemon may heal its own status conditions\nby shedding its skin."
  },
  "guts": {
    "name": "Guts",
    "num": 62,
    "desc": "It’s so gutsy that having a status condition boosts\nthe Pokemon’s Attack stat.",
    "shortDesc": "It’s so gutsy that having a status condition boosts\nthe Pokemon’s Attack stat."
  },
  "marvelscale": {
    "name": "Marvel Scale",
    "num": 63,
    "desc": "The Pokemon’s marvelous scales boost the Defense\nstat if it has a status condition.",
    "shortDesc": "The Pokemon’s marvelous scales boost the Defense\nstat if it has a status condition."
  },
  "liquidooze": {
    "name": "Liquid Ooze",
    "num": 64,
    "desc": "Oozed liquid has strong stench, which damages\nattackers using any draining move.",
    "shortDesc": "Oozed liquid has strong stench, which damages\nattackers using any draining move."
  },
  "overgrow": {
    "name": "Overgrow",
    "num": 65,
    "desc": "Powers up Grass-type moves when the Pokemon’s\nHP is low.",
    "shortDesc": "Powers up Grass-type moves when the Pokemon’s\nHP is low."
  },
  "blaze": {
    "name": "Blaze",
    "num": 66,
    "desc": "Powers up Fire-type moves when the Pokemon’s HP\nis low.",
    "shortDesc": "Powers up Fire-type moves when the Pokemon’s HP\nis low."
  },
  "torrent": {
    "name": "Torrent",
    "num": 67,
    "desc": "Powers up Water-type moves when the Pokemon’s\nHP is low.",
    "shortDesc": "Powers up Water-type moves when the Pokemon’s\nHP is low."
  },
  "swarm": {
    "name": "Swarm",
    "num": 68,
    "desc": "Powers up Bug-type moves when the Pokemon’s HP\nis low.",
    "shortDesc": "Powers up Bug-type moves when the Pokemon’s HP\nis low."
  },
  "headstrong": {
    "name": "Headstrong",
    "num": 69,
    "desc": "Protects the Pokemon from recoil damage.",
    "shortDesc": "Protects the Pokemon from recoil damage."
  },
  "drought": {
    "name": "Drought",
    "num": 70,
    "desc": "Turns the sunlight harsh when the Pokemon enters\na battle.",
    "shortDesc": "Turns the sunlight harsh when the Pokemon enters\na battle."
  },
  "arenatrap": {
    "name": "Arena Trap",
    "num": 71,
    "desc": "Prevents opposing Pokemon from fleeing.",
    "shortDesc": "Prevents opposing Pokemon from fleeing."
  },
  "vitalspirit": {
    "name": "Vital Spirit",
    "num": 72,
    "desc": "The Pokemon is full of vitality, and that prevents\nit from falling asleep.",
    "shortDesc": "The Pokemon is full of vitality, and that prevents\nit from falling asleep."
  },
  "determination": {
    "name": "Determination",
    "num": 73,
    "desc": "The Pokemon is highly determined, which\nprevents other Pokemon from lowering its stats.",
    "shortDesc": "The Pokemon is highly determined, which\nprevents other Pokemon from lowering its stats."
  },
  "purepower": {
    "name": "Pure Power",
    "num": 74,
    "desc": "Using its pure power, the Pokemon doubles its\nAttack stat.",
    "shortDesc": "Using its pure power, the Pokemon doubles its\nAttack stat."
  },
  "shellarmor": {
    "name": "Shell Armor",
    "num": 75,
    "desc": "A hard shell protects the Pokemon from critical hits.",
    "shortDesc": "A hard shell protects the Pokemon from critical hits."
  },
  "airlock": {
    "name": "Air Lock",
    "num": 76,
    "desc": "Eliminates the effects of weather.",
    "shortDesc": "Eliminates the effects of weather."
  },
  "tangledfeet": {
    "name": "Tangled Feet",
    "num": 77,
    "desc": "Raises evasion if the Pokemon is confused.",
    "shortDesc": "Raises evasion if the Pokemon is confused."
  },
  "motordrive": {
    "name": "Motor Drive",
    "num": 78,
    "desc": "Boosts its Speed stat if hit by an Electric-type move,\ninstead of taking damage.",
    "shortDesc": "Boosts its Speed stat if hit by an Electric-type move,\ninstead of taking damage."
  },
  "rivalry": {
    "name": "Rivalry",
    "num": 79,
    "desc": "Becomes competitive and deals more damage to\nPokemon of the same gender, but deals less to\nPokemon of the opposite gender.",
    "shortDesc": "Becomes competitive and deals more damage to\nPokemon of the same gender, but deals less to\nPokemon of the opposite gender."
  },
  "steadfast": {
    "name": "Steadfast",
    "num": 80,
    "desc": "The Pokemon’s determination boosts the Speed\nstat each time the Pokemon flinches.",
    "shortDesc": "The Pokemon’s determination boosts the Speed\nstat each time the Pokemon flinches."
  },
  "snowcloak": {
    "name": "Snow Cloak",
    "num": 81,
    "desc": "Boosts evasion in a hailstorm.",
    "shortDesc": "Boosts evasion in a hailstorm."
  },
  "gluttony": {
    "name": "Gluttony",
    "num": 82,
    "desc": "Makes the Pokemon eat a held Berry when its HP\ndrops to half or less, which is sooner than usual.",
    "shortDesc": "Makes the Pokemon eat a held Berry when its HP\ndrops to half or less, which is sooner than usual."
  },
  "angerpoint": {
    "name": "Anger Point",
    "num": 83,
    "desc": "The Pokemon is angered when it takes a critical hit,\nand that maxes its Attack stat.",
    "shortDesc": "The Pokemon is angered when it takes a critical hit,\nand that maxes its Attack stat."
  },
  "unburden": {
    "name": "Unburden",
    "num": 84,
    "desc": "Boosts the Speed stat if the Pokemon’s held item is \nused or lost.",
    "shortDesc": "Boosts the Speed stat if the Pokemon’s held item is \nused or lost."
  },
  "heatproof": {
    "name": "Heatproof",
    "num": 85,
    "desc": "The heatproof body of the Pokemon halves the\ndamage from Fire-type moves that hit it.",
    "shortDesc": "The heatproof body of the Pokemon halves the\ndamage from Fire-type moves that hit it."
  },
  "simple": {
    "name": "Simple",
    "num": 86,
    "desc": "The stat changes the Pokemon receives are doubled.",
    "shortDesc": "The stat changes the Pokemon receives are doubled."
  },
  "dryskin": {
    "name": "Dry Skin",
    "num": 87,
    "desc": "Restores HP in rain or when hit by Water-type\nmoves. Reduces HP in harsh sunlight, and increases\nthe damage received from Fire-type moves.",
    "shortDesc": "Restores HP in rain or when hit by Water-type\nmoves. Reduces HP in harsh sunlight, and increases\nthe damage received from Fire-type moves."
  },
  "instinct": {
    "name": "Instinct",
    "num": 88,
    "desc": "Compares an opposing Pokemon’s Defense and\nSp. Def stats before raising its own Attack or\nSp. Atk stat by 1.5x.",
    "shortDesc": "Compares an opposing Pokemon’s Defense and\nSp. Def stats before raising its own Attack or\nSp. Atk stat by 1.5x."
  },
  "amplifier": {
    "name": "Amplifier",
    "num": 89,
    "desc": "Boosts the power of Sound-based moves by 20%.\nFind a detailed list on the Google Sheet.",
    "shortDesc": "Boosts the power of Sound-based moves by 20%.\nFind a detailed list on the Google Sheet."
  },
  "poisonheal": {
    "name": "Poison Heal",
    "num": 90,
    "desc": "Restores HP if the Pokemon is poisoned, instead of\nlosing HP.",
    "shortDesc": "Restores HP if the Pokemon is poisoned, instead of\nlosing HP."
  },
  "adaptability": {
    "name": "Adaptability",
    "num": 91,
    "desc": "Moves that are the same type as the user\ndeal 2x damage instead of 1.5x.",
    "shortDesc": "Moves that are the same type as the user\ndeal 2x damage instead of 1.5x."
  },
  "skilllink": {
    "name": "Skill Link",
    "num": 92,
    "desc": "Maximizes the number of times multi-strike\nmoves hit.",
    "shortDesc": "Maximizes the number of times multi-strike\nmoves hit."
  },
  "hydration": {
    "name": "Hydration",
    "num": 93,
    "desc": "Heals status conditions if it’s raining.",
    "shortDesc": "Heals status conditions if it’s raining."
  },
  "solarpower": {
    "name": "Solar Power",
    "num": 94,
    "desc": "Boosts the Sp. Atk stat in harsh sunlight, but HP\ndecreases every turn.",
    "shortDesc": "Boosts the Sp. Atk stat in harsh sunlight, but HP\ndecreases every turn."
  },
  "quickfeet": {
    "name": "Quick Feet",
    "num": 95,
    "desc": "Boosts the Speed stat if the Pokemon has a\nstatus condition.",
    "shortDesc": "Boosts the Speed stat if the Pokemon has a\nstatus condition."
  },
  "normalize": {
    "name": "Normalize",
    "num": 96,
    "desc": "All the Pokemon’s moves become Normal type.\nThe power of those moves is boosted a little.",
    "shortDesc": "All the Pokemon’s moves become Normal type.\nThe power of those moves is boosted a little."
  },
  "ruthless": {
    "name": "Ruthless",
    "num": 97,
    "desc": "Powers up moves if they become critical hits\nto 2.25x damage instead of 1.5x.",
    "shortDesc": "Powers up moves if they become critical hits\nto 2.25x damage instead of 1.5x."
  },
  "magicguard": {
    "name": "Magic Guard",
    "num": 98,
    "desc": "The Pokemon only takes damage from attacks.",
    "shortDesc": "The Pokemon only takes damage from attacks."
  },
  "noguard": {
    "name": "No Guard",
    "num": 99,
    "desc": "The Pokemon employs no-guard tactics to ensure\nincoming and outgoing attacks always land.",
    "shortDesc": "The Pokemon employs no-guard tactics to ensure\nincoming and outgoing attacks always land."
  },
  "stagnantstate": {
    "name": "Stagnant State",
    "num": 100,
    "desc": "The Pokemon moves after all other Pokemon do.",
    "shortDesc": "The Pokemon moves after all other Pokemon do."
  },
  "technician": {
    "name": "Technician",
    "num": 101,
    "desc": "Powers up the Pokemon’s moves by 1.5x if they\nare 60 Base Power or less.",
    "shortDesc": "Powers up the Pokemon’s moves by 1.5x if they\nare 60 Base Power or less."
  },
  "leafguard": {
    "name": "Leaf Guard",
    "num": 102,
    "desc": "Prevents status conditions in harsh sunlight.",
    "shortDesc": "Prevents status conditions in harsh sunlight."
  },
  "klutz": {
    "name": "Klutz",
    "num": 103,
    "desc": "The Pokemon can’t use any held items.",
    "shortDesc": "The Pokemon can’t use any held items."
  },
  "moldbreaker": {
    "name": "Mold Breaker",
    "num": 104,
    "desc": "Moves can be used on the target regardless of\nits Abilities.",
    "shortDesc": "Moves can be used on the target regardless of\nits Abilities."
  },
  "superluck": {
    "name": "Super Luck",
    "num": 105,
    "desc": "The Pokemon is so lucky that the critical-hit ratios\nof its moves are boosted.",
    "shortDesc": "The Pokemon is so lucky that the critical-hit ratios\nof its moves are boosted."
  },
  "oldaftermath": {
    "name": "Old Aftermath",
    "num": 106,
    "desc": "Damages the attacker if it contacts the Pokemon\nwith a finishing hit.",
    "shortDesc": "Damages the attacker if it contacts the Pokemon\nwith a finishing hit."
  },
  "anticipation": {
    "name": "Anticipation",
    "num": 107,
    "desc": "The Pokemon can sense an opposing Pokemon’s\ndangerous moves.",
    "shortDesc": "The Pokemon can sense an opposing Pokemon’s\ndangerous moves."
  },
  "forewarn": {
    "name": "Forewarn",
    "num": 108,
    "desc": "When it enters a battle, the Pokemon can tell one of\nthe moves an opposing Pokemon has.",
    "shortDesc": "When it enters a battle, the Pokemon can tell one of\nthe moves an opposing Pokemon has."
  },
  "unaware": {
    "name": "Unaware",
    "num": 109,
    "desc": "When attacking, the Pokemon ignores the target\nPokemon’s stat changes.",
    "shortDesc": "When attacking, the Pokemon ignores the target\nPokemon’s stat changes."
  },
  "tintedlens": {
    "name": "Tinted Lens",
    "num": 110,
    "desc": "The Pokemon can use “not very effective” moves\nto deal regular damage.",
    "shortDesc": "The Pokemon can use “not very effective” moves\nto deal regular damage."
  },
  "filter": {
    "name": "Filter",
    "num": 111,
    "desc": "Reduces the power of supereffective attacks\ntaken by 25%.",
    "shortDesc": "Reduces the power of supereffective attacks\ntaken by 25%."
  },
  "slowstart": {
    "name": "Slow Start",
    "num": 112,
    "desc": "For five turns, the Pokemon’s Attack and Speed\nstats are halved.",
    "shortDesc": "For five turns, the Pokemon’s Attack and Speed\nstats are halved."
  },
  "scrappy": {
    "name": "Scrappy",
    "num": 113,
    "desc": "The Pokemon can hit Ghost-type Pokemon with\nNormal- and Fighting-type moves.",
    "shortDesc": "The Pokemon can hit Ghost-type Pokemon with\nNormal- and Fighting-type moves."
  },
  "stormdrain": {
    "name": "Storm Drain",
    "num": 114,
    "desc": "Draws in all Water-type moves. Instead of being hit \nby Water-type moves, it boosts its Sp. Atk.",
    "shortDesc": "Draws in all Water-type moves. Instead of being hit \nby Water-type moves, it boosts its Sp. Atk."
  },
  "icebody": {
    "name": "Ice Body",
    "num": 115,
    "desc": "The Pokemon gradually regains HP in a hailstorm.",
    "shortDesc": "The Pokemon gradually regains HP in a hailstorm."
  },
  "solidrock": {
    "name": "Solid Rock",
    "num": 116,
    "desc": "Reduces the power of supereffective attacks taken.",
    "shortDesc": "Reduces the power of supereffective attacks taken."
  },
  "snowwarning": {
    "name": "Snow Warning",
    "num": 117,
    "desc": "The Pokemon summons a hailstorm when it enters\na battle.",
    "shortDesc": "The Pokemon summons a hailstorm when it enters\na battle."
  },
  "honeygather": {
    "name": "Honey Gather",
    "num": 118,
    "desc": "The Pokemon may gather Honey after a battle.",
    "shortDesc": "The Pokemon may gather Honey after a battle."
  },
  "frisk": {
    "name": "Frisk",
    "num": 119,
    "desc": "When it enters a battle, the Pokemon can check an\nopposing Pokemon’s held item.",
    "shortDesc": "When it enters a battle, the Pokemon can check an\nopposing Pokemon’s held item."
  },
  "reckless": {
    "name": "Reckless",
    "num": 120,
    "desc": "Powers up moves that have recoil damage.",
    "shortDesc": "Powers up moves that have recoil damage."
  },
  "multitype": {
    "name": "Multitype",
    "num": 121,
    "desc": "Changes the Pokemon’s type to match the Plate or\nZ-Crystal it holds.",
    "shortDesc": "Changes the Pokemon’s type to match the Plate or\nZ-Crystal it holds."
  },
  "flowergift": {
    "name": "Flower Gift",
    "num": 122,
    "desc": "Boosts the Attack and Sp. Def stats of itself\nand allies in harsh sunlight by 1.5x.",
    "shortDesc": "Boosts the Attack and Sp. Def stats of itself\nand allies in harsh sunlight by 1.5x."
  },
  "baddreams": {
    "name": "Bad Dreams",
    "num": 123,
    "desc": "Reduces the HP of sleeping opposing Pokemon.",
    "shortDesc": "Reduces the HP of sleeping opposing Pokemon."
  },
  "pickpocket": {
    "name": "Pickpocket",
    "num": 124,
    "desc": "Steals an item from an attacker that made\ndirect contact.",
    "shortDesc": "Steals an item from an attacker that made\ndirect contact."
  },
  "sheerforce": {
    "name": "Sheer Force",
    "num": 125,
    "desc": "Removes additional effects to increase the power\nof moves when attacking.",
    "shortDesc": "Removes additional effects to increase the power\nof moves when attacking."
  },
  "contrary": {
    "name": "Contrary",
    "num": 126,
    "desc": "Makes stat changes have an opposite effect.",
    "shortDesc": "Makes stat changes have an opposite effect."
  },
  "unnerve": {
    "name": "Unnerve",
    "num": 127,
    "desc": "Unnerves opposing Pokemon and makes them unable\nto eat Berries.",
    "shortDesc": "Unnerves opposing Pokemon and makes them unable\nto eat Berries."
  },
  "defiant": {
    "name": "Defiant",
    "num": 128,
    "desc": "Boosts the Pokemon’s Attack stat sharply when its\nstats are lowered.",
    "shortDesc": "Boosts the Pokemon’s Attack stat sharply when its\nstats are lowered."
  },
  "defeatist": {
    "name": "Defeatist",
    "num": 129,
    "desc": "Halves the Pokemon’s Attack and Sp. Atk stats\nwhen its HP becomes half or less.",
    "shortDesc": "Halves the Pokemon’s Attack and Sp. Atk stats\nwhen its HP becomes half or less."
  },
  "cursedbody": {
    "name": "Cursed Body",
    "num": 130,
    "desc": "May disable a move used on the Pokemon.",
    "shortDesc": "May disable a move used on the Pokemon."
  },
  "healer": {
    "name": "Healer",
    "num": 131,
    "desc": "Sometimes heals an ally’s status condition.",
    "shortDesc": "Sometimes heals an ally’s status condition."
  },
  "friendguard": {
    "name": "Friend Guard",
    "num": 132,
    "desc": "Reduces damage done to allies.",
    "shortDesc": "Reduces damage done to allies."
  },
  "weakarmor": {
    "name": "Weak Armor",
    "num": 133,
    "desc": "Physical attacks to the Pokemon lower its Defense\nstat but sharply raise its Speed stat.",
    "shortDesc": "Physical attacks to the Pokemon lower its Defense\nstat but sharply raise its Speed stat."
  },
  "heavymetal": {
    "name": "Heavy Metal",
    "num": 134,
    "desc": "Doubles the Pokemon’s weight.",
    "shortDesc": "Doubles the Pokemon’s weight."
  },
  "lightmetal": {
    "name": "Light Metal",
    "num": 135,
    "desc": "Halves the Pokemon’s weight.",
    "shortDesc": "Halves the Pokemon’s weight."
  },
  "multiscale": {
    "name": "Multiscale",
    "num": 136,
    "desc": "Reduces the amount of damage the Pokemon takes\nwhen its HP is full.",
    "shortDesc": "Reduces the amount of damage the Pokemon takes\nwhen its HP is full."
  },
  "toxicboost": {
    "name": "Toxic Boost",
    "num": 137,
    "desc": "Powers up physical attacks when the Pokemon\nis poisoned.",
    "shortDesc": "Powers up physical attacks when the Pokemon\nis poisoned."
  },
  "flareboost": {
    "name": "Flare Boost",
    "num": 138,
    "desc": "Powers up special attacks when the Pokemon\nis burned.",
    "shortDesc": "Powers up special attacks when the Pokemon\nis burned."
  },
  "harvest": {
    "name": "Harvest",
    "num": 139,
    "desc": "May create another Berry after one is used.",
    "shortDesc": "May create another Berry after one is used."
  },
  "telepathy": {
    "name": "Telepathy",
    "num": 140,
    "desc": "Anticipates an ally’s attack and dodges it.",
    "shortDesc": "Anticipates an ally’s attack and dodges it."
  },
  "moody": {
    "name": "Moody",
    "num": 141,
    "desc": "Raises one stat sharply and lowers another\nevery turn.",
    "shortDesc": "Raises one stat sharply and lowers another\nevery turn."
  },
  "overcoat": {
    "name": "Overcoat",
    "num": 142,
    "desc": "Protects the Pokemon from things like sand, hail,\nand powder.",
    "shortDesc": "Protects the Pokemon from things like sand, hail,\nand powder."
  },
  "poisontouch": {
    "name": "Poison Touch",
    "num": 143,
    "desc": "May poison a target when the Pokemon\nmakes contact.",
    "shortDesc": "May poison a target when the Pokemon\nmakes contact."
  },
  "regenerator": {
    "name": "Regenerator",
    "num": 144,
    "desc": "Restores a little HP when withdrawn from battle.",
    "shortDesc": "Restores a little HP when withdrawn from battle."
  },
  "bigpecks": {
    "name": "Big Pecks",
    "num": 145,
    "desc": "Protects the Pokemon from\nDefense-lowering effects.",
    "shortDesc": "Protects the Pokemon from\nDefense-lowering effects."
  },
  "sandrush": {
    "name": "Sand Rush",
    "num": 146,
    "desc": "Boosts the Pokemon’s Speed stat in a sandstorm.",
    "shortDesc": "Boosts the Pokemon’s Speed stat in a sandstorm."
  },
  "wonderskin": {
    "name": "Wonder Skin",
    "num": 147,
    "desc": "Makes status moves more likely to miss.",
    "shortDesc": "Makes status moves more likely to miss."
  },
  "analytic": {
    "name": "Analytic",
    "num": 148,
    "desc": "Boosts move power by 30% when the Pokemon moves last.",
    "shortDesc": "Boosts move power by 30% when the Pokemon moves last."
  },
  "illusion": {
    "name": "Illusion",
    "num": 149,
    "desc": "Comes out disguised as the Pokemon in the party’s\nlast spot.",
    "shortDesc": "Comes out disguised as the Pokemon in the party’s\nlast spot."
  },
  "imposter": {
    "name": "Imposter",
    "num": 150,
    "desc": "The Pokemon transforms itself into the Pokemon\nit’s facing.",
    "shortDesc": "The Pokemon transforms itself into the Pokemon\nit’s facing."
  },
  "infiltrator": {
    "name": "Infiltrator",
    "num": 151,
    "desc": "Passes through the opposing Pokemon’s barrier,\nsubstitute, and the like and strikes.",
    "shortDesc": "Passes through the opposing Pokemon’s barrier,\nsubstitute, and the like and strikes."
  },
  "gastroacid": {
    "name": "Gastro Acid",
    "num": 152,
    "desc": "Contact with the Pokemon changes the attacker’s\nAbility to Gastro Acid.",
    "shortDesc": "Contact with the Pokemon changes the attacker’s\nAbility to Gastro Acid."
  },
  "moxie": {
    "name": "Moxie",
    "num": 153,
    "desc": "The Pokemon shows moxie, and that boosts the\nAttack stat after knocking out any Pokemon.",
    "shortDesc": "The Pokemon shows moxie, and that boosts the\nAttack stat after knocking out any Pokemon."
  },
  "justified": {
    "name": "Justified",
    "num": 154,
    "desc": "Being hit by a Dark-type move boosts the Attack\nstat of the Pokemon, for justice.",
    "shortDesc": "Being hit by a Dark-type move boosts the Attack\nstat of the Pokemon, for justice."
  },
  "rattled": {
    "name": "Rattled",
    "num": 155,
    "desc": "Dark-, Ghost-, and Bug-type moves scare the\nPokemon and boost its Speed stat.",
    "shortDesc": "Dark-, Ghost-, and Bug-type moves scare the\nPokemon and boost its Speed stat."
  },
  "magicbounce": {
    "name": "Magic Bounce",
    "num": 156,
    "desc": "Reflects status moves, instead of getting hit\nby them.",
    "shortDesc": "Reflects status moves, instead of getting hit\nby them."
  },
  "sapsipper": {
    "name": "Sap Sipper",
    "num": 157,
    "desc": "Boosts the Attack stat if hit by a Grass-type move,\ninstead of taking damage.",
    "shortDesc": "Boosts the Attack stat if hit by a Grass-type move,\ninstead of taking damage."
  },
  "prankster": {
    "name": "Prankster",
    "num": 158,
    "desc": "Gives +1 priority to a status move.",
    "shortDesc": "Gives +1 priority to a status move."
  },
  "sandforce": {
    "name": "Sand Force",
    "num": 159,
    "desc": "Boosts the power of Rock-, Ground-, and Steel-type\nmoves in a sandstorm by 30%.",
    "shortDesc": "Boosts the power of Rock-, Ground-, and Steel-type\nmoves in a sandstorm by 30%."
  },
  "ironbarbs": {
    "name": "Iron Barbs",
    "num": 160,
    "desc": "Inflicts damage to the attacker on contact with\niron barbs.",
    "shortDesc": "Inflicts damage to the attacker on contact with\niron barbs."
  },
  "zenmode": {
    "name": "Zen Mode",
    "num": 161,
    "desc": "Changes the Pokemon’s shape when HP is half\nor less.",
    "shortDesc": "Changes the Pokemon’s shape when HP is half\nor less."
  },
  "luminescent": {
    "name": "Luminescent",
    "num": 162,
    "desc": "Boosts accuracy by 10% for this side of the field.\nBoth this Pokemon and any allies are affected.",
    "shortDesc": "Boosts accuracy by 10% for this side of the field.\nBoth this Pokemon and any allies are affected."
  },
  "turboblaze": {
    "name": "Turboblaze",
    "num": 163,
    "desc": "Moves can be used on the target regardless of\nits Abilities.",
    "shortDesc": "Moves can be used on the target regardless of\nits Abilities."
  },
  "teravolt": {
    "name": "Teravolt",
    "num": 164,
    "desc": "Moves can be used on the target regardless of\nits Abilities.",
    "shortDesc": "Moves can be used on the target regardless of\nits Abilities."
  },
  "aromaveil": {
    "name": "Aroma Veil",
    "num": 165,
    "desc": "Protects itself and its allies from attacks that limit\ntheir move choices.",
    "shortDesc": "Protects itself and its allies from attacks that limit\ntheir move choices."
  },
  "flowerveil": {
    "name": "Flower Veil",
    "num": 166,
    "desc": "The user, and any other Grass-type allies\nare immune to status conditions and\ncannot have their stats lowered",
    "shortDesc": "The user, and any other Grass-type allies\nare immune to status conditions and\ncannot have their stats lowered"
  },
  "metabolism": {
    "name": "Metabolism",
    "num": 167,
    "desc": "Restores 1/3 HP after eating ANY berry.",
    "shortDesc": "Restores 1/3 HP after eating ANY berry."
  },
  "versatility": {
    "name": "Versatility",
    "num": 168,
    "desc": "Changes the Pokemon’s type to the type of the\nmove it’s about to use.",
    "shortDesc": "Changes the Pokemon’s type to the type of the\nmove it’s about to use."
  },
  "furcoat": {
    "name": "Fur Coat",
    "num": 169,
    "desc": "Halves the damage from physical moves.",
    "shortDesc": "Halves the damage from physical moves."
  },
  "magician": {
    "name": "Magician",
    "num": 170,
    "desc": "The Pokemon steals the held item of a Pokemon it\nhits with a move.",
    "shortDesc": "The Pokemon steals the held item of a Pokemon it\nhits with a move."
  },
  "bulletproof": {
    "name": "Bulletproof",
    "num": 171,
    "desc": "Protects the Pokemon from some ball and\nbomb moves. Full list on DoozDex.",
    "shortDesc": "Protects the Pokemon from some ball and\nbomb moves. Full list on DoozDex."
  },
  "competitive": {
    "name": "Competitive",
    "num": 172,
    "desc": "Boosts the Sp. Atk stat sharply when a stat\nis lowered.",
    "shortDesc": "Boosts the Sp. Atk stat sharply when a stat\nis lowered."
  },
  "strongjaw": {
    "name": "Strong Jaw",
    "num": 173,
    "desc": "The Pokemon’s strong jaw boosts the power of its\nbiting moves by 50%.",
    "shortDesc": "The Pokemon’s strong jaw boosts the power of its\nbiting moves by 50%."
  },
  "refrigerate": {
    "name": "Refrigerate",
    "num": 174,
    "desc": "Normal-type moves become Ice-type moves.\nThe power of those moves is boosted by 20%.",
    "shortDesc": "Normal-type moves become Ice-type moves.\nThe power of those moves is boosted by 20%."
  },
  "sweetveil": {
    "name": "Sweet Veil",
    "num": 175,
    "desc": "Prevents itself and ally Pokemon from falling asleep.",
    "shortDesc": "Prevents itself and ally Pokemon from falling asleep."
  },
  "stancechange": {
    "name": "Stance Change",
    "num": 176,
    "desc": "The Pokemon changes its form to Blade Forme when\nit uses an attack move, and changes to Shield Forme\nwhen it uses King’s Shield.",
    "shortDesc": "The Pokemon changes its form to Blade Forme when\nit uses an attack move, and changes to Shield Forme\nwhen it uses King’s Shield."
  },
  "galewings": {
    "name": "Gale Wings",
    "num": 177,
    "desc": "Gives priority to Flying-type moves when the \nPokemon’s HP is full.",
    "shortDesc": "Gives priority to Flying-type moves when the \nPokemon’s HP is full."
  },
  "megalauncher": {
    "name": "Mega Launcher",
    "num": 178,
    "desc": "Powers up aura and pulse moves by 50%.",
    "shortDesc": "Powers up aura and pulse moves by 50%."
  },
  "grassyguard": {
    "name": "Grassy Guard",
    "num": 179,
    "desc": "Boosts the Pokemon’s Defense stat in \nGrassy Terrain by 50%.",
    "shortDesc": "Boosts the Pokemon’s Defense stat in \nGrassy Terrain by 50%."
  },
  "symbiosis": {
    "name": "Symbiosis",
    "num": 180,
    "desc": "The Pokemon passes its item to an ally that has\nused up an item.",
    "shortDesc": "The Pokemon passes its item to an ally that has\nused up an item."
  },
  "toughclaws": {
    "name": "Tough Claws",
    "num": 181,
    "desc": "Powers up moves that make direct contact.",
    "shortDesc": "Powers up moves that make direct contact."
  },
  "pixilate": {
    "name": "Pixilate",
    "num": 182,
    "desc": "Normal-type moves become Fairy-type moves.\nThe power of those moves is boosted a little.",
    "shortDesc": "Normal-type moves become Fairy-type moves.\nThe power of those moves is boosted a little."
  },
  "gooey": {
    "name": "Gooey",
    "num": 183,
    "desc": "Contact with the Pokemon lowers the attacker’s\nSpeed stat.",
    "shortDesc": "Contact with the Pokemon lowers the attacker’s\nSpeed stat."
  },
  "aerilate": {
    "name": "Aerilate",
    "num": 184,
    "desc": "Normal-type moves become Flying-type moves.\nThe power of those moves is boosted a little.",
    "shortDesc": "Normal-type moves become Flying-type moves.\nThe power of those moves is boosted a little."
  },
  "expertise": {
    "name": "Expertise",
    "num": 185,
    "desc": "Makes all moves hit twice. The second hit is\n25% the power of the first.",
    "shortDesc": "Makes all moves hit twice. The second hit is\n25% the power of the first."
  },
  "darkaura": {
    "name": "Dark Aura",
    "num": 186,
    "desc": "Powers up each Pokemon’s Dark-type\nmoves by 33%. With STAB, this stacks to a 95% boost.",
    "shortDesc": "Powers up each Pokemon’s Dark-type\nmoves by 33%. With STAB, this stacks to a 95% boost."
  },
  "fairyaura": {
    "name": "Fairy Aura",
    "num": 187,
    "desc": "Powers up each Pokemon’s Fairy-type\nmoves by 33%. With STAB, this stacks to a 95% boost.",
    "shortDesc": "Powers up each Pokemon’s Fairy-type\nmoves by 33%. With STAB, this stacks to a 95% boost."
  },
  "distortion": {
    "name": "Distortion",
    "num": 188,
    "desc": "The effects of “Aura” Abilities are reversed\nto lower the power of affected moves by 25%.",
    "shortDesc": "The effects of “Aura” Abilities are reversed\nto lower the power of affected moves by 25%."
  },
  "stormyseas": {
    "name": "Stormy Seas",
    "num": 189,
    "desc": "The Pokemon changes the weather to nullify\nFire-type attacks, and summon heavy rain.",
    "shortDesc": "The Pokemon changes the weather to nullify\nFire-type attacks, and summon heavy rain."
  },
  "swelteringsun": {
    "name": "Sweltering Sun",
    "num": 190,
    "desc": "The Pokemon changes the weather to nullify\nWater-type attacks, and summon intense sun.",
    "shortDesc": "The Pokemon changes the weather to nullify\nWater-type attacks, and summon intense sun."
  },
  "guardinggale": {
    "name": "Guarding Gale",
    "num": 191,
    "desc": "The Pokemon changes the weather to eliminate all\nof the Flying type’s weaknesses.",
    "shortDesc": "The Pokemon changes the weather to eliminate all\nof the Flying type’s weaknesses."
  },
  "stamina": {
    "name": "Stamina",
    "num": 192,
    "desc": "Boosts the Defense stat when hit by an attack.",
    "shortDesc": "Boosts the Defense stat when hit by an attack."
  },
  "wimpout": {
    "name": "Wimp Out",
    "num": 193,
    "desc": "The Pokemon cowardly switches out when its HP\nbecomes half or less.",
    "shortDesc": "The Pokemon cowardly switches out when its HP\nbecomes half or less."
  },
  "emergencyexit": {
    "name": "Emergency Exit",
    "num": 194,
    "desc": "The Pokemon, sensing danger, switches out when its\nHP becomes half or less.",
    "shortDesc": "The Pokemon, sensing danger, switches out when its\nHP becomes half or less."
  },
  "watercompaction": {
    "name": "Water Compaction",
    "num": 195,
    "desc": "Boosts the Pokemon’s Defense stat sharply when hit\nby a Water-type move.",
    "shortDesc": "Boosts the Pokemon’s Defense stat sharply when hit\nby a Water-type move."
  },
  "merciless": {
    "name": "Merciless",
    "num": 196,
    "desc": "The Pokemon’s attacks become critical hits if the\ntarget is poisoned.",
    "shortDesc": "The Pokemon’s attacks become critical hits if the\ntarget is poisoned."
  },
  "shieldsdown": {
    "name": "Shields Down",
    "num": 197,
    "desc": "When its HP becomes half or less, the Pokemon’s\nshell breaks and it becomes aggressive.",
    "shortDesc": "When its HP becomes half or less, the Pokemon’s\nshell breaks and it becomes aggressive."
  },
  "stakeout": {
    "name": "Stakeout",
    "num": 198,
    "desc": "Doubles the damage dealt to the target’s\nreplacement if the target switches out.",
    "shortDesc": "Doubles the damage dealt to the target’s\nreplacement if the target switches out."
  },
  "liquidveil": {
    "name": "Liquid Veil",
    "num": 199,
    "desc": "DOUBLES the power of Water moves, prevents burn\nand halves damage taken from Fire moves.",
    "shortDesc": "DOUBLES the power of Water moves, prevents burn\nand halves damage taken from Fire moves."
  },
  "steelworker": {
    "name": "Steelworker",
    "num": 200,
    "desc": "Powers up Steel-type moves by 1.5x.",
    "shortDesc": "Powers up Steel-type moves by 1.5x."
  },
  "berserk": {
    "name": "Berserk",
    "num": 201,
    "desc": "Boosts the Pokemon’s Sp. Atk stat each time its\nHP drops below 50%.",
    "shortDesc": "Boosts the Pokemon’s Sp. Atk stat each time its\nHP drops below 50%."
  },
  "slushrush": {
    "name": "Slush Rush",
    "num": 202,
    "desc": "Doubles the Pokemon’s Speed stat in a hailstorm.",
    "shortDesc": "Doubles the Pokemon’s Speed stat in a hailstorm."
  },
  "longreach": {
    "name": "Long Reach",
    "num": 203,
    "desc": "The Pokemon uses its moves without making contact\nwith the target.",
    "shortDesc": "The Pokemon uses its moves without making contact\nwith the target."
  },
  "liquidvibration": {
    "name": "Liquid Vibration",
    "num": 204,
    "desc": "All sound-based moves become Water-type moves.",
    "shortDesc": "All sound-based moves become Water-type moves."
  },
  "rapidfire": {
    "name": "Rapid Fire",
    "num": 205,
    "desc": "Moves that can hit 3 or more times gain +3 priority.\nExplosion, Detonate some others do as well.",
    "shortDesc": "Moves that can hit 3 or more times gain +3 priority.\nExplosion, Detonate some others do as well."
  },
  "galvanize": {
    "name": "Galvanize",
    "num": 206,
    "desc": "Normal-type moves become Electric-type moves.\nThe power of those moves is boosted a little.",
    "shortDesc": "Normal-type moves become Electric-type moves.\nThe power of those moves is boosted a little."
  },
  "voltrush": {
    "name": "Volt Rush",
    "num": 207,
    "desc": "Doubles the Pokemon’s Speed stat on\nElectric Terrain.",
    "shortDesc": "Doubles the Pokemon’s Speed stat on\nElectric Terrain."
  },
  "schooling": {
    "name": "Schooling",
    "num": 208,
    "desc": "When it has a lot of HP, the Pokemon forms a\npowerful school. It stops schooling when its HP\nis low.",
    "shortDesc": "When it has a lot of HP, the Pokemon forms a\npowerful school. It stops schooling when its HP\nis low."
  },
  "disguise": {
    "name": "Disguise",
    "num": 209,
    "desc": "Once per battle, the shroud that covers the\nPokemon can protect it from an attack.",
    "shortDesc": "Once per battle, the shroud that covers the\nPokemon can protect it from an attack."
  },
  "battlebond": {
    "name": "Battle Bond",
    "num": 210,
    "desc": "Defeating an opposing Pokemon strengthens the\nPokemon’s bond with its Trainer, and it becomes\nAsh-Greninja. Water Shuriken gets more powerful.",
    "shortDesc": "Defeating an opposing Pokemon strengthens the\nPokemon’s bond with its Trainer, and it becomes\nAsh-Greninja. Water Shuriken gets more powerful."
  },
  "powerconstruct": {
    "name": "Power Construct",
    "num": 211,
    "desc": "Other Cells gather to aid when its HP becomes\nhalf or less. Then the Pokemon changes\nits form to Complete Forme.",
    "shortDesc": "Other Cells gather to aid when its HP becomes\nhalf or less. Then the Pokemon changes\nits form to Complete Forme."
  },
  "corrosion": {
    "name": "Corrosion",
    "num": 212,
    "desc": "The Pokemon can poison the target even if it’s\na Steel or Poison type.",
    "shortDesc": "The Pokemon can poison the target even if it’s\na Steel or Poison type."
  },
  "comatose": {
    "name": "Comatose",
    "num": 213,
    "desc": "It’s always drowsing and will never wake up.\nIt can attack without waking up.",
    "shortDesc": "It’s always drowsing and will never wake up.\nIt can attack without waking up."
  },
  "queenlymajesty": {
    "name": "Queenly Majesty",
    "num": 214,
    "desc": "Its majesty pressures the opposing Pokemon,\nmaking it unable to attack using priority moves.",
    "shortDesc": "Its majesty pressures the opposing Pokemon,\nmaking it unable to attack using priority moves."
  },
  "aftermath": {
    "name": "Aftermath",
    "num": 215,
    "desc": "Damages the attacker landing the finishing hit\nby the amount equal to its last HP.",
    "shortDesc": "Damages the attacker landing the finishing hit\nby the amount equal to its last HP."
  },
  "envy": {
    "name": "Envy",
    "num": 216,
    "desc": "When another Pokemon uses a setup move,\nthis copies the move immediately after.",
    "shortDesc": "When another Pokemon uses a setup move,\nthis copies the move immediately after."
  },
  "battery": {
    "name": "Battery",
    "num": 217,
    "desc": "Powers up ally Pokemon’s special moves.",
    "shortDesc": "Powers up ally Pokemon’s special moves."
  },
  "fluffy": {
    "name": "Fluffy",
    "num": 218,
    "desc": "Halves the damage taken from moves that make\ndirect contact, but doubles that of Fire-type moves.",
    "shortDesc": "Halves the damage taken from moves that make\ndirect contact, but doubles that of Fire-type moves."
  },
  "dazzling": {
    "name": "Dazzling",
    "num": 219,
    "desc": "Dazzles the opposing Pokemon, making it unable\nto attack using priority moves.",
    "shortDesc": "Dazzles the opposing Pokemon, making it unable\nto attack using priority moves."
  },
  "hubris": {
    "name": "Hubris",
    "num": 220,
    "desc": "Boosts its Sp. Atk stat every time a Pokemon faints.",
    "shortDesc": "Boosts its Sp. Atk stat every time a Pokemon faints."
  },
  "tanglinghair": {
    "name": "Tangling Hair",
    "num": 221,
    "desc": "Contact with the Pokemon lowers the attacker’s\nSpeed stat.",
    "shortDesc": "Contact with the Pokemon lowers the attacker’s\nSpeed stat."
  },
  "receiver": {
    "name": "Receiver",
    "num": 222,
    "desc": "The Pokemon copies the Ability of a defeated ally.",
    "shortDesc": "The Pokemon copies the Ability of a defeated ally."
  },
  "powerofalchemy": {
    "name": "Power of Alchemy",
    "num": 223,
    "desc": "The Pokemon copies the Ability of a defeated ally.",
    "shortDesc": "The Pokemon copies the Ability of a defeated ally."
  },
  "proficiency": {
    "name": "Proficiency",
    "num": 224,
    "desc": "The Pokemon boosts its most proficient stat each\ntime it knocks out a Pokemon.",
    "shortDesc": "The Pokemon boosts its most proficient stat each\ntime it knocks out a Pokemon."
  },
  "rkssystem": {
    "name": "RKS System",
    "num": 225,
    "desc": "Changes the Pokemon’s type to match the\nmemory disc it holds.",
    "shortDesc": "Changes the Pokemon’s type to match the\nmemory disc it holds."
  },
  "electricsurge": {
    "name": "Electric Surge",
    "num": 226,
    "desc": "Turns the ground into Electric Terrain when the\nPokemon enters a battle.",
    "shortDesc": "Turns the ground into Electric Terrain when the\nPokemon enters a battle."
  },
  "psychicsurge": {
    "name": "Psychic Surge",
    "num": 227,
    "desc": "Turns the ground into Psychic Terrain when\nthe Pokemon enters a battle.",
    "shortDesc": "Turns the ground into Psychic Terrain when\nthe Pokemon enters a battle."
  },
  "mistysurge": {
    "name": "Misty Surge",
    "num": 228,
    "desc": "Turns the ground into Misty Terrain when\nthe Pokemon enters a battle.",
    "shortDesc": "Turns the ground into Misty Terrain when\nthe Pokemon enters a battle."
  },
  "grassysurge": {
    "name": "Grassy Surge",
    "num": 229,
    "desc": "Turns the ground into Grassy Terrain when\nthe Pokemon enters a battle.",
    "shortDesc": "Turns the ground into Grassy Terrain when\nthe Pokemon enters a battle."
  },
  "birdseyeview": {
    "name": "Bird's Eye View",
    "num": 230,
    "desc": "Prevents other Pokemon’s moves or Abilities from\nlowering the Pokemon’s stats.",
    "shortDesc": "Prevents other Pokemon’s moves or Abilities from\nlowering the Pokemon’s stats."
  },
  "energyshield": {
    "name": "Energy Shield",
    "num": 231,
    "desc": "Halves the amount of damage the Pokemon takes\nwhile its HP is full.",
    "shortDesc": "Halves the amount of damage the Pokemon takes\nwhile its HP is full."
  },
  "resilient": {
    "name": "Resilient",
    "num": 232,
    "desc": "Reduces super effective damage taken by 25%.",
    "shortDesc": "Reduces super effective damage taken by 25%."
  },
  "neuroforce": {
    "name": "Neuroforce",
    "num": 233,
    "desc": "Boosts it's super effective moves by 25%.",
    "shortDesc": "Boosts it's super effective moves by 25%."
  }
}